import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Languages } from '@/components/Global/I18N/domain';

export const useBrowserLanguageSync = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        const syncLanguage = () => {
            const browserLanguage = navigator.language;
            const baseLanguage = browserLanguage.split('-')[0].toLowerCase();

            const supportedLanguages = Object.values(Languages);
            const isSupported = supportedLanguages.includes(baseLanguage as Languages);

            if (!isSupported) {
                return;
            }

            const currentLanguage = i18n.language.split('-')[0].toLowerCase();

            if (currentLanguage !== baseLanguage) {
                i18n.changeLanguage(baseLanguage);
            }
        };

        syncLanguage();

        window.addEventListener('focus', syncLanguage);
        window.addEventListener('languagechange', syncLanguage);

        return () => {
            window.removeEventListener('focus', syncLanguage);
            window.removeEventListener('languagechange', syncLanguage);
        };
    }, [i18n]);
};
